import React, { useState, useCallback, useMemo } from 'react';
import { toast } from 'sonner';
import { AuthErrorContext, type AuthErrorState } from './AuthErrorContext';




export const AuthErrorProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [authErrorState, setAuthErrorState] = useState<AuthErrorState>({
    hasAuthError: false,
    isRefreshing: false,
    errorMessage: null,
  });

  const setAuthError = useCallback((message: string) => {
    setAuthErrorState(prev => ({
      ...prev,
      hasAuthError: true,
      errorMessage: message,
    }));
  }, []);

  const clearAuthError = useCallback(() => {
    setAuthErrorState({
      hasAuthError: false,
      isRefreshing: false,
      errorMessage: null,
    });
  }, []);

  const setRefreshing = useCallback((isRefreshing: boolean) => {
    setAuthErrorState(prev => ({
      ...prev,
      isRefreshing,
    }));
  }, []);

  const showTokenExpiredNotification = useCallback(() => {
    toast.error('Sesión Expirada', {
      description:
        'Tu sesión ha expirado. Serás redirigido al login en unos segundos.',
      duration: 5000,
    });
  }, []);

  const value = useMemo(
      () => ({
        authErrorState,
        setAuthError,
        clearAuthError,
        setRefreshing,
        showTokenExpiredNotification,
      }),
      [authErrorState, setAuthError, clearAuthError, setRefreshing, showTokenExpiredNotification]
    );

  return (
    <AuthErrorContext.Provider value={value}>
      {children}
    </AuthErrorContext.Provider>
  );
};
